import React, { useEffect, createElement } from 'react';
import { SalesLetterPage } from './pages/SalesLetterPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
    _fbqInitialized?: boolean;
  }
}
export function App() {
  useEffect(() => {
    // Prevent double-fire in React StrictMode
    if (window._fbqInitialized) return;
    window._fbqInitialized = true;
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Safe insertion: use existing script tag or fall back to document.head
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
    }
    window.fbq('init', '1435718891550072');
    window.fbq('track', 'PageView');
  }, []);
  return <>
      <SalesLetterPage data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1435718891550072&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
    </>;
}